import ComponentElement from 'components/component-element';
import SelectionsSlider from 'components/selections-slider';

function SimilarNearbyHotels($element, options = {}) {
    ComponentElement.call(this, $element, options);
}

SimilarNearbyHotels.prototype = Object.create(ComponentElement.prototype);
Object.defineProperty(SimilarNearbyHotels.prototype, 'constructor', {
    value: ComponentElement,
    writable: true,
    enumerable: false,
});

SimilarNearbyHotels.prototype._initSelectionsSlider = function() {
    this.$element.querySelectorAll('.js-selections-slider').forEach($element => new SelectionsSlider($element, {
        swiper: {
            breakpoints: {
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                },
            },
        },
    }));

    if (this.$element.querySelectorAll('.Selections__item').length === 0) {
        this.hide();
    }
}

SimilarNearbyHotels.prototype.hide = function() {
    this.$element.classList.add('is-hidden');
}

SimilarNearbyHotels.prototype.show = function() {
    this.$element.classList.remove('is-hidden');
}

SimilarNearbyHotels.prototype.hasForcedRender = function() {
    return this.$element.dataset.forcedRender == 1;
}

SimilarNearbyHotels.prototype.setSelectionsHTML = function(html) {
    if (!html) return;

    const $items = this.$element.querySelector('.js-similarNearbyHotelsItems');

    this.show();

    while ($items.children.length) {
        $items.children[0].remove();
    }

    $items.insertAdjacentHTML('afterbegin', html);

    this._initSelectionsSlider();
}

export default SimilarNearbyHotels;
